import { submitOnlineBookingSelectStaffThunk } from 'actions/onlineBooking/OnlineBookingActions';
import { PoweredByCuddles } from 'components/Cuddles/PoweredBy/PoweredByCuddles';
import { LeftColumn } from 'components/Layout/TwoColumns/LeftColumn/LeftColumn';
import { RightColumn } from 'components/Layout/TwoColumns/RightColumn/RightColumn';
import { MarketplaceInfo } from 'components/Marketplace/Info/MarketplaceInfo';
import { OnlineBookingResume } from 'components/OnlineBooking/Resume/OnlineBookingResume';
import { NoAvailability } from 'components/OnlineBooking/Steps/SelectStaff/NoAvailability/NoAvailability';
import { StaffSelector } from 'components/OnlineBooking/Steps/SelectStaff/StaffSelector/StaffSelector';
import { Button } from 'components/UI/Button/Button';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    getOnlineBookingItems,
    getOnlineBookingSelectedStaffId,
    getOnlineBookingStaffs
} from 'reducers/onlineBooking/OnlineBookingSelectors';

export const OnlineBookingSelectStaffStep: React.FC = () => {
    const dispatch = useDispatch();
    const marketplace = useMarketplace();

    const staffs = useSelector(getOnlineBookingStaffs);
    const bookingItems = useSelector(getOnlineBookingItems);
    const defaultSelectedStaffId = useSelector(getOnlineBookingSelectedStaffId);

    const [selectedStaffId, setSelectedStaffId] = React.useState<number | null>(
        defaultSelectedStaffId
    );

    const noStaffPerformsBookingServices = React.useMemo(() => {
        return !staffs.some(staffItem => {
            return bookingItems.every(item => {
                return item.service?.staffIds.includes(staffItem.staff.id);
            });
        });
    }, [bookingItems, staffs]);

    const submitHandler = React.useCallback(() => {
        dispatch(submitOnlineBookingSelectStaffThunk(selectedStaffId));
    }, [dispatch, selectedStaffId]);

    return (
        <>
            <LeftColumn contentClassName="flex flex-col flex-1">
                {/* contentClassName={noStaffPerformsBookingServices ? 'h-full' : ''} */}
                <h1 className="h1 underlined w-full mb-6">Select staff</h1>

                {noStaffPerformsBookingServices && <NoAvailability />}

                {!noStaffPerformsBookingServices && (
                    <StaffSelector
                        selectedStaffId={selectedStaffId}
                        onSelected={setSelectedStaffId}
                    />
                )}

                <div className="mt-auto hide-on-mobile-and-tablet pt-6">
                    <PoweredByCuddles />
                </div>
            </LeftColumn>

            <RightColumn
                poweredByCuddles
                footer={
                    <Button
                        fullWidth
                        disabled={noStaffPerformsBookingServices}
                        onClick={submitHandler}
                    >
                        Continue
                    </Button>
                }
            >
                <div className="flex flex-col gap-5 hide-on-mobile-and-tablet">
                    <MarketplaceInfo inverted marketplace={marketplace} />

                    <OnlineBookingResume />
                </div>
            </RightColumn>
        </>
    );
};
